import React from 'react'

type Props = {
   as?: 'main' | 'div' | 'ul'
   className?: string
   children: React.ReactNode
}

const QueryResultContainer = ({ as: Tag = 'main', className = '', children }: Props) => (
   <Tag className={`container px-[8px] sm:px-[20px] lg:px-40 ${className}`.trim()}>{children}</Tag>
)

export default QueryResultContainer
